import { Injectable } from '@angular/core';
import { Selector } from '@ngxs/store';
import { AuthenticationState } from './authentication.state';
import { AuthenticationStateModel } from './authentication.state-model';

@Injectable()
export class AuthenticationSelectors {
  @Selector([AuthenticationState])
  static accessToken(state: AuthenticationStateModel): string {
    return state.accessToken;
  }

  @Selector([AuthenticationState])
  static userId(state: AuthenticationStateModel): string {
    return state.userId;
  }

  @Selector([AuthenticationState])
  static userName(state: AuthenticationStateModel): string {
    return state.name;
  }

  @Selector([AuthenticationState])
  static email(state: AuthenticationStateModel): string {
    return state.email;
  }

  @Selector([AuthenticationState])
  static picture(state: AuthenticationStateModel): string {
    return state.picture;
  }

  @Selector([AuthenticationState])
  static permissions(state: AuthenticationStateModel): string[] {
    return state.permissions;
  }

  @Selector([AuthenticationState])
  static isAuthenticated(state: AuthenticationStateModel): boolean {
    return state.isAuthenticated;
  }

  @Selector([AuthenticationState])
  static qrCode(state: AuthenticationStateModel): string {
    return state.qrCode;
  }
}
